<script setup>
defineProps({
  src: { type: String, required: true },
  title: { type: String, default: '' },
})
</script>
<template>
  <iframe
    :src="src"
    :title="title"
    class="external-frame"
    allow="fullscreen"
  />
</template>
<style scoped>
.external-frame {
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  border: 0;
  display: block;
}
</style>
